import { z } from 'zod';
/**
 * Nguồn đồng bộ và máy chủ git **của tổ chức** — APM-ORGINT-a,
 * docs/plan-org-integrations.md.
 *
 * File này giữ phần dùng chung của cả hai: công tắc "cho phép địa chỉ nội bộ"
 * theo tổ chức (§5). Hình của nguồn / máy chủ vẫn ở `project-sync.ts` / `git.ts`.
 */
/**
 * Super admin bật / tắt cho **một** tổ chức (`organization.allow_private_network`).
 *
 * Mặc định tắt: nguồn / máy chủ do admin tổ chức khai, và một địa chỉ loopback /
 * RFC1918 / link-local là SSRF vào chính mạng của bản cài. Bật cho tổ chức có
 * GitLab / Redmine trong mạng công ty.
 */
export const SetOrgPrivateNetworkInput = z.object({
    allowPrivateNetwork: z.boolean(),
});
/** Một dòng ở danh sách tổ chức của super admin (APM-ORGINT-d). */
export const OrgPrivateNetworkView = z.object({
    orgId: z.uuid(),
    name: z.string(),
    isDemo: z.boolean(),
    isPersonal: z.boolean(),
    allowPrivateNetwork: z.boolean(),
    /** Số nguồn đồng bộ + máy chủ git tổ chức đang có — để super admin biết tắt là đụng ai. */
    syncProviderCount: z.number().int().nonnegative(),
    gitHostCount: z.number().int().nonnegative(),
});
export const OrgPrivateNetworkList = z.object({
    orgs: z.array(OrgPrivateNetworkView),
});
//# sourceMappingURL=org-integration.js.map